import Content from "~/components/layout/Content";
import { Button } from "~/components/ui/button";

const FeatureRequest = () => {
    return (
        <Content>
            <div className='container mx-auto py-10'>
                <h1 className='text-2xl font-bold mb-6'>Bug Report Board</h1>
                <div className='flex flex-col gap-8'>
                    {/* Erstes Iframe */}
                    <iframe 
                        src="https://kalialab.notion.site/ebd/211b2a843ddd8044abc3db8ac3ff7838" 
                        width="100%" 
                        height="600" 
                        frameborder="0" 
                        allowfullscreen 
                    />
                    
                    {/* Zweites Iframe hinzugefügt */}
                    <iframe 
                        src="https://kalialab.notion.site/ebd/211b2a843ddd80229faecf0610e6db4a" 
                        width="100%" 
                        height="1500" 
                        frameborder="0" 
                        allowfullscreen 
                    />
                    
                    {/* Der Make Feature Request Button wurde entfernt */}
                </div>
            </div>
        </Content>
    );
};

export default FeatureRequest;
